/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_Focus_ChallengeInputs */

const en_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's Go!`)
};

const ar_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هيا بنا!`)
};

const de_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los geht's!`)
};

const es_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Vamos!`)
};

const fr_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est parti !`)
};

const it_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andiamo!`)
};

const ja_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さあ、行こう！`)
};

const ko_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출발!`)
};

const pt_br_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos lá!`)
};

const ru_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поехали!`)
};

const th_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปกันเลย!`)
};

const tr_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadi başlayalım!`)
};

const zh_cn_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出发吧！`)
};

const zh_tw_unlock_focus_challenge = /** @type {(inputs: Unlock_Focus_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出發吧！`)
};

/**
* | output |
* | --- |
* | "Let's Go!" |
*
* @param {Unlock_Focus_ChallengeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_focus_challenge = /** @type {((inputs?: Unlock_Focus_ChallengeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Focus_ChallengeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_focus_challenge(inputs)
	if (locale === "ar") return ar_unlock_focus_challenge(inputs)
	if (locale === "de") return de_unlock_focus_challenge(inputs)
	if (locale === "es") return es_unlock_focus_challenge(inputs)
	if (locale === "fr") return fr_unlock_focus_challenge(inputs)
	if (locale === "it") return it_unlock_focus_challenge(inputs)
	if (locale === "ja") return ja_unlock_focus_challenge(inputs)
	if (locale === "ko") return ko_unlock_focus_challenge(inputs)
	if (locale === "pt_br") return pt_br_unlock_focus_challenge(inputs)
	if (locale === "ru") return ru_unlock_focus_challenge(inputs)
	if (locale === "th") return th_unlock_focus_challenge(inputs)
	if (locale === "tr") return tr_unlock_focus_challenge(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_focus_challenge(inputs)
	return zh_tw_unlock_focus_challenge(inputs)
});